<template>
  <div class="flex flex-wrap gap-1 items-center group w-full pl-2 pr-2 py-1.5">
    <TagsBadgePlusModal
      :variant="maxTablet ? undefined : 'property'"
      :title="$t('components.passport.tags.title')"
      :badgeAddLabel="
        asset.tags.length > 0 ? null : $t('components.passport.tags.add')
      "
      :description="$t('components.task_details.tags.description')"
      :initialState="asset.tags"
      :readonly="readonly"
      :buildingIds="[asset.tenant.id]"
      :displayTitle="false"
      @update="updateTags"
    />
  </div>
</template>
<script setup>
import axios from "axios";
import route from "ziggy-js";
import { Tags as TagsBadgePlusModal } from "@/SharedComponents/Parts";
import { useBreakpoints } from "@/Composables/useBreakpoints";
import { toast } from "@/SharedComponents/Toaster";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
const { maxTablet } = useBreakpoints();
const emit = defineEmits(["update", "update:item"]);
const props = defineProps({
  asset: { type: Object, required: true },
  readonly: { type: Boolean, required: false },
  variant: { type: String, required: false },
  title: { type: String, required: false },
  description: { type: String, required: false },
  initialState: { type: Array, default: () => [] },
  buildingIds: { type: Array, required: false },
});

function updateTags(data) {
  if (props.readonly) {
    return;
  }

  axios
    .post(route("api.tags.asset.update"), {
      space_id: props.asset.id,
      tag_ids: data.map((tag) => tag.id),
    })
    .then(() => {
      toast.success(t("toasts.assets.update.success"));
    })
    .catch(() => {
      toast.error(t("toasts.assets.update.error"));
    })
    .finally(() => {
      emit("update:item", {
        item: {
          ...props.asset,
          tags: data,
        },
      });
    });
}
</script>
